/**
 * *Global Reducers Constants
 * */
export const GLOBAL_UPDATE_ROUTE = 'global_update_route';
export const GLOBAL_SIDER_COLLAPSED = 'global_sider_collapsed';
export const GLOBAL_SIDER_MENU = 'global_sider_menu';
export const GLOBAL_PAGES_PAGINATION = 'global_pages_pagination';
export const GLOBAL_PAGES_FILTER_DATA = 'global_pages_filter_data';
export const GLOBAL_PAGES_FILTER_TOGGLE = 'global_pages_filter_toggle';
